const styles = ({ spacing: { unit } }) => ({
  content: {
    height: 'auto',
    maxHeight: 450,
    overflowY: 'scroll'
  },
  innerContent: {
    padding: `${unit * 7.5}px`
  },

  header: {
    '& .glu-react-icon': {
      display: 'inline-block',
      margin: '0 3px'
    }
  }
});

export default styles;
